import {
    MTG_PENDING,
    MTG_DECLINED,
    MTG_ATTENDING,
    MTG_TENTATIVE,
    TIMEOUT,
    TIMEOUT_PLACEHOLDER,
    VOTE_YES,
    VOTE_NO,
    VOTE_ABSTAIN,
    VOTE_PENDING,
    BT_FROM_EMAIL_ADDRESS,
} from './constants';

export const DEFAULT_ERROR_MSG =
    'There has been an error on the system.  Please try again. If the problem persists, please contact your administrator.';
export const DOC_TOKEN_ERROR_HEADER_MSG = 'Document token error';
export const DOC_TOKEN_ERROR_CONTENT_MSG =
    'We encountered a problem retrieving this file. Please click on Update to try again.';
export const TIMEOUT_HEADER_MSG = `Your session has been inactive for ${TIMEOUT / 60000} minutes.`;
export const TIMEOUT_CONTENT_MSG = `You will be logged out in ${TIMEOUT_PLACEHOLDER} seconds unless you choose to continue?`;

// export const PAGE_ERROR_CLASS = " alert-danger ";
export const FIELD_STANDARD_CLASS = 'form-group row ';
export const FIELD_ERROR_CLASS = 'form-group row has-danger ';

export const PWD_INVALID_MSG =
    'Password must be 8-50 characters; contain at least one lowercase, uppercase, number (123), and special character (#$@).';
export const USERNAME_INVALID_MSG =
    'Username must be 5-50 characters and contain only alphanumeric characters.';
export const SIGNIN_INVALID_MSG = 'Oops, the username or password you entered is incorrect.';
export const SIGNIN_REAUTHENTICATE_MSG = 'To ensure your security, the system requires you to periodically re-sign in.'
export const CONFIRM_PWD_INVALID_MSG = "Confirmation Password doesn't match the password.";
export const EMAIL_INVALID_MSG = 'The email address is not in the right format.';
export const FRIENDLY_TOKEN_INVALID_MSG =
    'The authentication code must be 6 characters and contain only alphanumeric characters.';
export const FORGOTTEN_CONFIRMATION_MSG = `If you don't see your reset email be sure to check your spam filter for an email from ${BT_FROM_EMAIL_ADDRESS}`;
export const FORGOTTEN_CONFIRMATION_MSG_TITLE = 'If this address is recorded in Boardtrac, a reset email will be sent.';
export const SERVER_ERROR = 'There has been an error with your request. Please try again.';
export const USERNAME_INCORRECT_MSG =
    'Username is incorrect. Please refer to the reset email for your valid username.';
export const INVITATION_EXPIRED_MSG = 'Your reset password token has expired.';
export const MANDATORY_FIELD =
    'You have left [FIELDNAME] blank which is required. Please enter in your [FIELDNAME].';
export const FIELD_LENGTH = '[FIELDNAME] is limited to [FIELDLENGTH] characters, Please try again.';
export const ALPHANUMERICSPACE_ONLY = 'Only alphanumeric characters may be used.';
export const LOGO_PATH_INVALID_MESSAGE =
    "You're session has ended due to inactivity, the page will now reload.";
export const ERROR_OPEN_DOCUMENT_TITLE = 'That file appears to be missing.  Please try refreshing.';
export const ERROR_OPEN_DOCUMENT_MSG = `If the problem persists, please contact your administrator.`;

export function getAttendeePlaceholderText(attendee) {
    switch (attendee) {
        case MTG_PENDING:
            return 'Everyone has responded with their attendance';
        case MTG_DECLINED:
            return 'No-one has declined this meeting';
        case MTG_ATTENDING:
            return 'No-one has confirmed their attendance';
        case MTG_TENTATIVE:
            return 'No-one has responded as tentatively attending';
        default:
            return 'attendee';
    }
}

export function getVoteResultPlaceholderText(result) {
    switch (result) {
        case VOTE_PENDING:
            return 'Everyone has responded with vote';
        case VOTE_ABSTAIN:
            return 'No-one has abstained from this vote';
        case VOTE_NO:
            return 'No-one has responded with NO vote';
        case VOTE_YES:
            return 'No-one has responded with YES vote';
        default:
            return 'vote result';
    }
}

export const PAIRCOMPANY_INITAL_MSG =
    'If you have been sent an email invitation to join Boardtrac from an additional company simply enter the access code from your new company invitation.';
export const PAIRCOMPANY_EXPIRE_MSG =
    'User not found or the invitation expired. Please contact your administrator';
export const PAIRCOMPANY_INVALID_MSG =
    'Your secure access code is invalid. Please contact your administrator for a new one to be sent to your email.';

//#region PIN VARIABLES
export const PIN_CREATE_TITLE = "Create a PIN";
export const PIN_CREATE_PAGE_TEXT = "A PIN protects your Boardtrac account, allows you to unlock your application more easily whilst adding a level of security.";
export const PIN_CONFIRM_TITLE = "Confirm PIN";
export const PIN_CONFIRM_PAGE_TEXT = "Please confirm your PIN by entering it again.";
export const PIN_UNLOCK_TITLE = "Sign in with PIN";
export const PIN_UNLOCK_PAGE_TEXT = "Enter the PIN you setup when you first signed in to Boardtrac to allow access to your secure information.";
export const PIN_CONFIRM_ERROR_MESSAGE = "Entered PINs do not match, please try again."
export const PIN_BUTTON_TEXT_CREATE = "Return to Sign in";
export const PIN_BUTTON_TEXT_UNLOCK = "Forgot PIN? Or, different user?";
export const PIN_THREE_TIMES_UNLOCK_MESSAGE = "If you make a third unsuccessful attempt, you will be asked to login using your username and password.";
//#endregion\

export const DOC_NOTDOWNLOADED_MSG = "Your device is offline and the document has not been previously downloaded.  If possible, please connect to the internet before trying again."
export const DOC_NOTDOWNLOADED_TITLE = "Cannot open this document."
export const LOCK_SYSTEM_ERROR_MSG = "Application access has been temporarily locked due to security reasons. Please contact your company administrator."
export const WARNING_MESSAGE_ON_PIN_UNLOCK_SCREEN = "Signing in as a different user will erase the previous user's PIN."
export const ELECTRON_LOGIN_USER_OFFLINE_MESSAGE = "Your appear to be offline. Please connect to the Internet before logging in."
export const REFRESH_BTN_OFFLINE_MSG = "You are offline";
export const FETCH_ERROR_TITLE = "The Internet connection appears to be offline.";
export const FETCH_ERROR_MSG = "Your device appears to be offline. Please connect to the internet to refresh content.";

export const TCS_TITLE = "Boardtrac End User Terms of Use";
export const TCS_BUTTON = "Print";
export const TCS_MSG = "TCS_MSG";
export const TCS_PDF_TCS = "https://www.boardtrac.com.au/enduserterms.pdf";
export const TCS_PDF_PRIVACY = "https://www.boardtrac.com.au/privacy-policy/";
export const TCS_EMAIL = "BoardtracSupport@boardtrac.com.au";

export const NO_VOTE_MESSAGE = "The group administrator has restricted you from seeing other people’s votes.";



// WEBPACK FOOTER //
// ./src/helpers/messageText.js